import { cloneElement } from "react";
import type { MouseEvent } from "react";
import type { MultiSelectPanelHeaderTemplateEvent } from "primereact/multiselect";

import { MultiSelect } from "@/ds";
import type { QuickMultiSelectFilterProps } from "./types-quick-multi-select-filter";

export function QuickMultiSelectFilterView({
  onChange,
  onClear,
  optionValue = "value",
  ...props
}: QuickMultiSelectFilterProps) {
  // Cabeçalho do painel do próprio PrimeReact; só o clique do "x" muda: também limpa a seleção.
  function renderPanelHeader({
    className,
    closeElement,
    onCloseClick,
  }: MultiSelectPanelHeaderTemplateEvent) {
    return (
      <div className={className}>
        {cloneElement(closeElement, {
          "aria-label": "Limpar seleção e fechar",
          onClick: (event: MouseEvent<HTMLElement>) => {
            onClear?.();
            onCloseClick(event);
          },
        })}
      </div>
    );
  }

  return (
    <MultiSelect
      showSelectAll={false}
      panelHeaderTemplate={onClear ? renderPanelHeader : undefined}
      {...props}
      optionLabel="label"
      optionValue={optionValue}
      onChange={(event) => onChange(event.value as string[])}
    />
  );
}
